const getFiscalYear = ({years = [], category}) =>
  [...years].find((fiscalYear) =>
    fiscalYear?.period?.toLowerCase?.()?.includes?.(category?.toLowerCase?.())
  ) || null;

export default getFiscalYear;
